import React from 'react';
import useTheme from '../hooks/useTheme';

interface CardProps {
  children: React.ReactNode;
  hoverable?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ children, hoverable = false, style = {}, onClick }) => {
  const { theme } = useTheme();

  const baseStyle: React.CSSProperties = {
    backgroundColor: theme.background.card,
    borderRadius: theme.borderRadius.r1,
    padding: '20px',
    border: `1px solid ${theme.colors.line}`,
    transition: 'all 0.2s ease',
    ...(onClick && { cursor: 'pointer' }),
    ...style,
  };

  const className = hoverable ? 'cardHover' : '';

  return (
    <div className={className} style={baseStyle} onClick={onClick}>
      {children}
    </div>
  );
};

